import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'roundNum', standalone: false })
export class RoundNumPipe implements PipeTransform {
  transform(value: number): number { return Math.round(value || 0); }
}

@Pipe({ name: 'truncate', standalone: false })
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number = 30): string {
    if (!value) return '—';
    return value.length > limit ? value.slice(0, limit) + '…' : value;
  }
}

@Pipe({ name: 'sumProp', standalone: false })
export class SumPropPipe implements PipeTransform {
  transform(arr: any[], prop: string): number {
    return (arr || []).reduce((s, x) => s + (x[prop] || 0), 0);
  }
}

@Pipe({ name: 'maxVal', standalone: false })
export class MaxValPipe implements PipeTransform {
  transform(arr: any[], prop: string): number {
    if (!arr || arr.length === 0) return 0;
    return Math.max(...arr.map(x => x[prop] || 0));
  }
}

@Pipe({ name: 'paidCount', standalone: false })
export class PaidCountPipe implements PipeTransform {
  transform(arr: any[]): number {
    return (arr || []).filter(r => r.paymentStatus === 'paid').length;
  }
}

@Pipe({ name: 'activityCountByCat', standalone: false })
export class ActivityCountByCatPipe implements PipeTransform {
  transform(activities: any[], cat: string): number {
    return (activities || []).filter(a => a.category === cat).length;
  }
}
